const captionCls = "_rsc148l26j";
const titleCls = "_rst14t06wj";
const subCaptionCls = "_rsslucn7q";
const descriptionCls = "_rsd16x7u8i";
const spanCls = "_rss12q3wwp";
const scrambleCls = "_rss1sbsy5t";

export { captionCls, descriptionCls, scrambleCls, spanCls, subCaptionCls, titleCls };
import "./Caption.linaria.module.css";
//# sourceMappingURL=Caption.js.map
